const styles = {
    fullNameText: {
        fontSize: "2.2vh",
        color: "rgb(45,45,45)"
    },
    equeuesList: {
        paddingLeft: "17px"
    },
    listHeader: {
        fontFamily: 'Roboto',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '20px',
        letterSpacing: '0.1px',
        color: '#4E6D6F',
        marginTop: '6px',
        marginBottom: '17px',
        paddingLeft: "24px"
    }
}

export default styles;
